import React, { FC, createContext } from "react";
import { IComponentContextProps } from "./ComponentContext.types";

export const ComponentContext = createContext<IComponentContextProps>(null);

/**
 * A higher-order component (HOC) for providing/cascading the ComponentContext properties.
 * @param props The properties to pass to the component.
 * @returns A new react provider component.
 * @remarks Use this instead of repeatedly calling the `ComponentContext.Provider` and providing the context.
 */
export const ComponentContextProvider: FC<IComponentContextProps> = ({ children, ...context }) =>
  (<ComponentContext.Provider value={context}>{children}</ComponentContext.Provider>);